import LoginShell from "./_LoginShell";

export default function HotelLogin() {
  return (
    <LoginShell
      title="Portale Hotel"
      subtitle="Accedi con le credenziali fornite dal team Magniflex."
      role="hotel"
      redirect="/hotel"
      testid="hotel-login-page"
      otherRoleHref="/admin/login"
      otherRoleLabel="Accesso CMS riservato al team Magniflex"
    />
  );
}
